var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoSearchResults(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    draggable: "false",
    width: 65,
    height: 65,
    viewBox: "0 0 65 65",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M53.7153 51.0068H52.289L51.7834 50.5193C53.9501 47.9915 55.0695 44.5429 54.4556 40.8776C53.607 35.8582 49.4181 31.8498 44.3626 31.2359C36.7251 30.297 30.2973 36.7248 31.2362 44.3623C31.8501 49.4179 35.8584 53.6068 40.8778 54.4554C44.5431 55.0693 47.9917 53.9498 50.5195 51.7832L51.007 52.2887V53.7151L58.6806 61.3887C59.4209 62.129 60.6306 62.129 61.3709 61.3887C62.1112 60.6484 62.1112 59.4387 61.3709 58.6984L53.7153 51.0068ZM42.882 51.0068C38.3862 51.0068 34.757 47.3776 34.757 42.8818C34.757 38.3859 38.3862 34.7568 42.882 34.7568C47.3778 34.7568 51.007 38.3859 51.007 42.8818C51.007 47.3776 47.3778 51.0068 42.882 51.0068Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M57.7761 36.5441C57.0358 36.6498 56.3589 36.1307 56.1603 35.4096C54.9806 31.1245 51.2749 28.3837 47.1421 27.3258C46.4175 27.1403 45.9171 26.4485 46.04 25.7107C46.163 24.973 46.8619 24.4697 47.5884 24.6473C52.5597 25.8624 57.4489 29.2696 58.86 35.0231C59.0381 35.7494 58.5165 36.4383 57.7761 36.5441Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0816 49.7926C27.8093 49.6204 28.5312 50.0755 28.7833 50.7796C30.3166 55.0616 34.0479 57.6544 38.396 58.0988C39.14 58.1749 39.7483 58.7736 39.7483 59.5214C39.7483 60.2693 39.1406 60.8818 38.3954 60.8182C32.9045 60.3498 28.011 57.0294 26.1339 51.407C25.8971 50.6976 26.3538 49.9648 27.0816 49.7926Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_dd)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6667 6.33398H7.33333V9.50065H32.6667V6.33398ZM34.25 22.1673V19.0007L32.6667 11.084H7.33333L5.75 19.0007V22.1673H7.33333V31.6673H23.1667V22.1673H29.5V31.6673H32.6667V22.1673H34.25ZM20 28.5007H10.5V22.1673H20V28.5007Z"
  }))), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 22,
    width: 10,
    height: 7,
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_dd",
    x: -4.25,
    y: -2.66602,
    width: 48.5,
    height: 45.3333,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.08 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_dropShadow",
    result: "effect2_dropShadow"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect2_dropShadow",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 65,
    height: 65,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white",
    transform: "translate(1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoSearchResults);
export default __webpack_public_path__ + "static/media/no_search_results.17e95570.svg";
export { ForwardRef as ReactComponent };